<template>
  <div>
    <v-row class="mt-2" v-if="loadingTotalizers">
      <v-col cols="12" sm="4" md="4" lg="4" v-for="i in 3" :key="i">
        <v-skeleton-loader type="list-item-three-line" class="mb-3"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="mt-2" v-if="!!totalizadores && !loadingTotalizers">
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row align="center">
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{totalizadores.geral.oportunidades_total}}</div>
              <div class="text-h3">Oportunidades em aberto</div>
              <div class="mt-2">
                <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(totalizadores.geral.valor_total)}}</div>
                <div class="text-h3">Valor das oportunidades</div>
              </div>
              <div class="mt-2">
                <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(totalizadores.geral.ticket_medio)}}</div>
                <div class="text-h3">Ticket médio</div>
              </div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>handshake</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row align="center">
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{totalizadores.quentes.oportunidades_total}}</div>
              <div class="text-h3">Oportunidades quentes</div>
              <div class="mt-2">
                <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(totalizadores.quentes.valor_total)}}</div>
                <div class="text-h3">Valor das oportunidades</div>
              </div>
              <div class="mt-2">
                <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(totalizadores.quentes.valor_total)}}</div>
                <div class="text-h3">Ticket médio</div>
              </div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>local_fire_department</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row align="center">
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{totalizadores.adiadas.oportunidades_total}}</div>
              <div class="text-h3">Oportunidades adiadas</div>
              <div class="mt-2">
                <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(totalizadores.adiadas.valor_total)}}</div>
                <div class="text-h3">Valor das oportunidades</div>
              </div>
              <div class="mt-2">
                <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(totalizadores.adiadas.valor_total)}}</div>
                <div class="text-h3">Ticket médio</div>
              </div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>ac_unit</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Api from '@API'

export default {
  data () {
    return {
      loadingTotalizers: false,
      totalizadores: null
    }
  },
  methods: {
    async getTotalizers () {
      this.loadingTotalizers = true
      await Api.get('oportunidades/totalizador/abertas')
        .then(res => {
          if (res.data) {
            this.totalizadores = res.data
          }
          this.loadingTotalizers = false
        })
        .catch(err => {
          this.loadingTotalizers = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os totalizadores!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.getTotalizers()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/abertas/TotalizadorAberto.vue